import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Settings } from "../../../styles/theme"

import ads from "../../../images/placead.jpg"

const Cardstyle = styled.div`
  position: relative;
  margin: 5px;
  height: ${props => (props.height ? props.height : "580px")};
  @media screen and (max-width: ${Settings.sizeM}) {
    height: ${props => (props.height ? props.height : "300px")};
  }
  .content {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    z-index: 1;
    padding: 1rem;
    width: -webkit-fill-available;
    @media screen and (min-width: 375px) and (max-width: 767px) {
      min-width: 290px;
    }
  }
  img,
  .gatsby-image-wrapper {
    height: 100%;

  }
  > img, .gatsby-image-wrapper {
    positionL absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100% !important;
  }
  p {
    font-size: 12px;
  }
  h4,h5,h6 {
    margin: 0;
  }
`

export const Card = ({ fluid, children, height }) => (
  <Cardstyle height={height}>
    {fluid ? <Img fluid={fluid} /> : <img src={ads} />}
    {children !== undefined ? <div className="content">{children}</div> : ""}
  </Cardstyle>
)

const Flatstyle = styled.div`
  position: relative;
  flex: 1 1 30%;
  > div {
    margin: 1rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${Settings.secondaryColor};
  }
`

export const Flatcard = ({ fluid, json, slug }) => (
  <Flatstyle>
    <div>
      <Img fluid={fluid} />
      <div className="constraint">
        {documentToReactComponents(json)}
        <Link to={slug}>MORE >></Link>
      </div>
    </div>
  </Flatstyle>
)
